import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
//import logger from 'redux-logger';
import { CONSOLE_LOG } from '../config.js';
import { BRANCH_ACCESS } from '../constants/general';

let userData = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

let branches = JSON.parse(localStorage.getItem('userHigherAccess')) > BRANCH_ACCESS ? [] : userData.accesses && userData.accesses.filter(e => e.access_type === "branch") ;

const initialState = {
	newBilling:{
		type: "company",
		key: "",
		amount_e2: "",
		description: "",
		move:"add"
	},
	serviceSuppliers: [],
	parcialGivechange:{
		amount_e2:'',
		description:``,
		adjust_client_balance:false,
		add:"add"
	},
    companyPayment:{},
	featuredGoods:{},
	featuredGood:{},
	giveChangeHistory:[],
	etaConfig:{
		name:"",
		fixed_label:"",
		manufacturing_delay:0,
		manufacturing_count:0,
		manufacturing_cooldown:0,
		delivery_delay:0,
		mode:'',
		hour_from:'',
		hour_to:'',
		weekDays:[],
	},
	giveChange:{
		amount_e2:'',
		description:''
	},
	session: userData,
	userHigherAccess: localStorage.getItem('userHigherAccess') ? JSON.parse(localStorage.getItem('userHigherAccess')) : BRANCH_ACCESS,
    appMovilStatus:{},
    promotedBanner:{},
	aceptedpayment:{},
	adminWithoutAccess: false,
    goodType:"",
    providersVehicle:[],
    branchGroupsVehicle:[],
	vehicles:[],
	priceListId:{},
    vehicle:{
    	name:""
    },
	isUploadingExcel:false,
    confirmationOrder:{
		type: "gateway",
		name: "",
		ref: ""
    },
    coupon: {
		name:"",
		type:"",
		promo_code:"",
		human_price_prc:"",
		human_price_e2:"",
		applies_to:"",
		total_count:"",
		unlimited:false,
        config :{
        	limit:"",
			human_company_assumption_prc:"0",
			only_deliveries:false,
			only_first_purchase:false,
			usable_in_promos:false,
        }
	},
    companySubCategory:{
		name:"",
		in_order:null
    },
    initialBranch: {},
    new_service_skill_groups:'',
    service_skill_groups:[],
    allClients:[],
    showNotification:true,
	notificationsPaginated:[],
	hasDeletedSuccessfully: false,
    client:{},
	clients: [],
	paginated_clients: {
		current_page: 1,
		data: [],
		per_page: 10,
		total: 1
	},
	orderBranchRatings:[],
    cancelationReason:{},
    cancelationReasons:[],
    unseenNotifications: false, // user is aware by default
    newCancelationReason:'',
    category:{type:1},
    pendingActions:[],
    dolarToday:{},
    paymentResponse:{},
    paymentReference: {
        approved: [],
        pending: []
    },
    errorOnPaymentReference: null,
    branchGeoFence:{
    	name:"",
    	type:`circle`,
    	enabled:true,
    	data:{
    		radius:""
    	}
    },
    branchGeoFences:[],
    ordersCounter: {
    	"assigned": 0,
    	"unassigned": 0
    },
    branchGroupData:{
    	name:""
    },
    allCategories:[],
	app: {},
    autocomplete_results: [],
	order_client_address_query: "",
	branch: localStorage.getItem('activeBranch') ? JSON.parse(localStorage.getItem('activeBranch')) : {},
    branchHolidays: [],
    errorBranchHolidays: false,
	newBranch:{
		name:"",
    	description:"",
    	phone:"",
    	time_zone_offset:""
	},
	providerBranchAccesses: [],
	branches: branches || [],
    workSchedulesForOrdering: [],
	branchGroup: localStorage.getItem('activeBranchGroup') ? JSON.parse(localStorage.getItem('activeBranchGroup')) : {},
	branchGroups: [],
	branchGroupsByIds: [],
	branchCategory: {},
	branchCategories: [],
	company:{
    	id:'',
    },
	editable_company_settings: {},
	companies: [],
	currencies: {
		local: {},
		international: {},
		accepted: []
	},
    admin:{
    	id: '',
		name: '',
		display_name: '',
        phonePrefix: '58',
		phone: '',
		email: '',
    },
	admins: [],
	companySections: [],
	companySection: {
		type:"custom",
		payload:{
			type:"ids",
			ids:[]
		}
	},
    companyCities: [],
	branchAdmins: [],
    branchGroupsAdmins: [],
    companyAdmins: [],
    provider:{
    	id: '',
		name: '',
		display_name: '',
        phonePrefix: '58',
		phone: '',
		email: ''
    },
    providerSettings: {},
    providers: [],
		autocompleteProviders: [],
    invalidConfig: {},
    order:{
    	client_id:"",
    	client_latitude_e6:0,
    	client_longitude_e6:0,
    	scheduled_at:"",
    	notes:"",
    	goods:[],
    	providers_id:"",
    	propertiesGood:[],
			ordered_goods:[]
    },
    cartOrder:{},
    orderDetails:{
    	client_id:"",
    	client_latitude_e6:0,
    	client_longitude_e6:0,
    	scheduled_at:"",
    	notes:"",
    	goods:[],
    	providers_id:"",
    	propertiesGood:[],
		taxes:[]
    },
    orderHistory:{
        history: [],
        original_data: null
    },
    orderHistoryError:{
        error: null
    },
    hasToUpdateOrderView: false,
	orders:[],
	mapOrders: [],
    ordersBranchHeatmap: [],
    cancelOrderError: false,
	paginationOrders: {},
	filteredMapOrders: [],
	archived_orders: [],
    providerOrders: [],
    todayOrders:[],
    cart: {
        billing: {},
        branch: {},
        branch_id: null,
        client_id: null,
        created_at: null,
        currency_iso: null,
        delivery: {},
        id: null,
        items: [],
        payment_info: {},
        resume: {},
        status: null,
        updated_at: null
    },
    errorOnOrderPayment: null,
    couponCode: {
        error: null
    },
    errorOnRecreateOrder: null,
    payment_form:[],
    allPayments:[],
    account:{},
    accounts:{},
    goods: [],
    goodsList: [],
	good:{
		unit_config:null,
        unit_config_visible:false
	},
	isSidebarActive: false,
	isAsidemenuActive: false,
    dashboardStatistics: {},
    dashboardDaysStatistics: {},
    dashboardDaysStatisticsUpdate:{},
    dashboardMonthsStatistics:{},
    dashboardMonthsData:{},
	goodRatings: [],
	orderRatings: [],
	categoriesGood:[],
	branchPriceList:[],
    sendNotification:{
		title:"",
		body:"",
		target_type:""
	},
    associations: {
        current_page: 1,
		data: [],
		per_page: 100,
		total: 1,
        limit: 100
    },
	branchCurrency:{},
    newOrderTableRowAdded: "",  // id of the table row when a push notification of order type comes in
    properties:[],
    property:{disabled:false},
    propertiesGood:[],
    branchProperties:[],
    branchProperty:{disabled:true},
    branchPropertiesGood:[],
    dropzoneActive:false,
    dropzoneFiles:[],
	active_form:"",
    user: {},
    userIsOnline: JSON.parse(localStorage.getItem('userIsOnline')) === true ? true : false,
    users:      [],
    categories: [],
    apps:  [],
    templates:  [],
    layouts:    [],
    sections:   [],
    errors: {
        message: '',
        errors: {},
        preloader: ''
    },
    table: {
        ready: false,
        dataTransactions: [],
        limitTransactions: 2,
        pageTransactions: 1,
        ordTransactions: 'desc',
        sortTransactions: 'id',
        searchTransactions: '',
        mode:'all'
    },
	preloader: false,
	paymentMethods:{},
	paymentMethodsForms:[],
	notificationsCounter: 0,
	notificationPagination: {},
	notifications: [], // localStorage.getItem('notifications') ? JSON.parse(localStorage.getItem('notifications')) : [], /* for sidebar firebase push notifications */
	notification: {
		/* title: "", */
		message: "",
		level: 0  /* Available Levels:
			0 = DONT USE THIS ONE IS JUST FOR INITIALIZATION,
			1 = info,
			2 = success,
			3 = warning,
			4 = error
		*/
	},
	form:{
		answers:[],
	},
	productosConProveedoresAsignables:[],
	forms:{},
	reset_inputs: false,
	available_languages: {"es": {name: "Español", flag_code: "ve"}, "en": {name: "English", flag_code: "us"} }, /* xHACER: read this from disk json files?? */
	company_styles_json:{},
	terms_of_service: '',
	workSchedules: [],
	workSchedule: {},
	mapFilters: {
		// general
		goods: true,
		services: false,

		// providers
		availableProviders: true,
		unavailableProviders: true,
		offlineProviders: true,

		// orders
		unassigned: true,
		assigned: true,
		date: {
			todayOrders: false,
			thisWeekOrders: false,
			thisMonthOrders: true
		},

		// orders status
		canceled: false,
		delivered: false,
		ready: true, // in progress
		on_the_way: true,
		delayed: true,
		confirmed: true,
		payment_pending: true,
		payment_to_validate: true,
		//unconfirmed
	},
	lang_code: (localStorage.getItem('lang_code')) ? localStorage.getItem('lang_code') : localStorage.setItem('lang_code', "es"),
	properties_types:[
		{
			value:	256,
			name:localStorage.getItem('lang_code') ==='en'?"List":"Lista"
		},
		{
			value:	512,
			name:localStorage.getItem('lang_code') ==='en'?"Numeric":"Numérico"
		},
		{
			value:	1024,
			name:localStorage.getItem('lang_code') ==='en'?"Text":"Texto"
		}
	],
	json_lang: (require('../language/'+ localStorage.getItem('lang_code') +'.json')),
	customEmailFooter:'',
	customClientBg:'',
	deliveryFee:'',
	loginError: false,
    chats: {
        current_page: 1,
		data: [],
		per_page: 100,
		total: 1,
        limit: 100
    },
    chatMembers: {
        current_page: 1,
		data: [],
		per_page: 100,
		total: 1,
        limit: 100
    },
    activeInbox: false,
    newChatMember: false,
    providerChats: [],
    shopperChats: [],
    deliveryChats: [],
    chatUser: {},
    inovicesLot: [],
    fleetPaymentMethods: {
        config: {
            payment_methods: []
        }
    },
    localized_messages: [],
    banks: [],
    webhooks: {
        current_page: 1,
		data: [],
		per_page: 100,
		total: 1,
        limit: 100
    },
    webhook: {},
    webhooksOptions: {}
}

const reducer = (state = initialState, action) => {

	switch (action.type) {
        /*
		|---------------------------------
		|         ERRORS & AUTH          |
		|---------------------------------
		*/
        case "ERROR":
            return {
                ...state,
                preloader: false,
            };

        case "COMPANY_INITIALIZATION":
            return {
                ...state,
                company: action.company,
                initCompany: action.initCompany,
                currencies: action.currencies,
                lang_code: action.lang_code,
                company_styles_json: action.company_styles_json,
                json_lang: require("../language/" + action.lang_code + ".json"),
                customEmailFooter: action.customEmailFooter,
                customClientBg: action.customClientBg,
                deliveryFee: action.deliveryFee,
                preloader: false,
            };

        case "FETCH_COMPANY_SETTINGS":
            return {
                ...state,
                editable_company_settings: action.editable_company_settings,
                preloader: false,
            };

        case "COMPANY_EDITING":
            return {
                ...state,
                company: action.company,
                preloader: false,
            };

        case "RESPONSE":
            return {
                ...state,
                response: action.response,
                preloader: false,
            };

        case "REMOVE_LOADING":
            return {
                ...state,
                preloader: false,
            };

        case "LOGIN":
            return {
                ...state,
                session: action.user,
                branch: action.branch || {},
                branches: action.branches || [],
                userHigherAccess: action.userHigherAccess,
                branchGroups: action.branchGroups || [],
                preloader: false,
                loginError: false,
            };

        case "LOGIN_ERROR":
            return {
                ...state,
                adminWithoutAccess: action.adminWithoutAccess,
                loginError: true,
                preloader: false,
            };

        case "LOGOUT":
            return {
                ...state,
                session: action.user,
            };

        case "STATUS_ONLINE":
            return {
                ...state,
                userIsOnline: action.userIsOnline,
            };

        case "DASHBOARD":
            return {
                ...state,
                dashboardStatistics: action.dashboardStatistics,
            };

        case "DASHBOARD_DAYS":
            return {
                ...state,
                dashboardDaysStatistics: action.dashboardDaysStatistics,
            };

        case "DASHBOARD_MONTHS":
            return {
                ...state,
                dashboardMonthsStatistics: action.dashboardMonthsStatistics,
            };

        case "DASHBOARD_MONTHS_DATA":
            return {
                ...state,
                dashboardMonthsData: action.dashboardMonthsData,
            };

        case "DASHBOARD_DAYS_UPDATE":
            return {
                ...state,
                orderPast: action.orderPast,
            };

        case "REGISTER":
            return {
                ...state,
                user: action.user,
            };

        case "FETCH_ACCOUNT":
            return {
                ...state,
                account: action.account,
                preloader: false,
            };
        case "FETCH_ACCOUNTS":
            return {
                ...state,
                accounts: action.accounts,
                preloader: false,
            };

        case "USER_ONLINE_STATUS":
            return {
                ...state,
                userIsOnline: action.userIsOnline,
                timerId: action.timerId,
            };

        case 'GET_BANKS':
            return {
                ...state,
                banks: action.banks
            };
        /*
		|---------------------------------
		|        BRANCH                  |
		|---------------------------------
		*/

        case "FETCH_BRANCH":
            return {
                ...state,
                branch: { ...action.branch },
                initialBranch: { ...action.initialBranch },
                preloader: false,
            };

        case "FETCH_BRANCH_RATINGS":
            return {
                ...state,
                branchRatings: { ...action.branchRatings },
                preloader: false,
            };

        case "FETCH_ORDER_BRANCH_RATINGS":
            return {
                ...state,
                orderBranchRatings: [...action.orderBranchRatings],
                preloader: false,
            };

        case "FETCH_EDITABLEBRANCH":
            return {
                ...state,
                editableBranch: action.editableBranch,
                preloader: false,
            };

        case "UPDATE_BRANCH":
            return {
                ...state,
                branch: { ...action.branch },
                initialBranch: { ...action.initialBranch },
                editable_company_settings: {
                    ...action.editable_company_settings,
                },
                preloader: false,
            };

        case "UPDATE_NEWBRANCH":
            return {
                ...state,
                newBranch: { ...action.newBranch },
                initialBranch: { ...action.initialBranch },
                editable_company_settings: {
                    ...action.editable_company_settings,
                },
                preloader: false,
            };

        case "FETCH_BRANCH_ADMINS":
            return {
                ...state,
                branchAdmins: action.branchAdmins,
                preloader: false,
            };

        case "FETCH_BRANCHES":
            return {
                ...state,
                branches: action.branches,
                preloader: false,
            };
        case "FETCH_PROVIDER_BRANCHES_ACCESSES":
            return {
                ...state,
                providerBranchAccesses: action.providerBranchAccesses,
                preloader: false,
            };
        
        case "GET_WORK_SCHEDULES_FOR_ORDERING":
            return {
                ...state,
                workSchedulesForOrdering: action.workSchedulesForOrdering,
                preloader: false
            }

        case "BRANCH_HOLIDAYS":
            return {
                ...state,
                branchHolidays: action.branchHolidays,
                errorBranchHolidays: false,
                preloader: false
            }
        case "ERROR_BRANCH_HOLIDAYS":
            return {
                ...state,
                errorBranchHolidays: true,
                preloader: false
            }
        /*
		|---------------------------------
		|        BRANCH GROUPS		      |
		|---------------------------------
		*/

        case "FETCH_BRANCH_GROUPS_ADMINS":
            return {
                ...state,
                branchGroupsAdmins: action.branchGroupsAdmins,
                preloader: false,
            };

        case "FETCH_BRANCH_GROUP_DATA":
            return {
                ...state,
                branchGroupData: action.branchGroupData,
                preloader: false,
            };

        case "FETCH_ETA_CONFIG_DATA":
            return {
                ...state,
                etaConfigData: action.etaConfigData,
                preloader: false,
            };
        case "FETCH_ETA_ID_CONFIG_DATA":
            return {
                ...state,
                etaConfig: action.etaConfig,
                preloader: false,
            };

        case "FETCH_BRANCH_GROUPS_IDS":
            return {
                ...state,
                branchGroupsByIds: action.branchGroupsByIds,
                preloader: false,
            };

        case "FETCH_BRANCH_GROUP_LIST":
            return {
                ...state,
                branchGroupList: action.branchGroupList,
                preloader: false,
            };
        case "FETCH_BRANCH_GROUP_DATA_SETTINGS":
            return {
                ...state,
                branchGroupSettings: action.branchGroupSettings,
                preloader: false,
            };

        case "FETCH_BRANCH_GROUPS":
            return {
                ...state,
                branchGroups: action.branchGroups,
                preloader: false,
            };

        /* case "FETCH_BRANCH_GROUP_LIST":
            return {
                ...state,
                branchGroupList: action.branchGroupList,
                preloader: false,
            }; */

        case "DELETE_BRANCH_GROUP":
            return {
                ...state,
                branchGroupList: action.branchGroupList,
                branchGroups: action.branchGroups,
                hasDeletedSuccessfully: action.hasDeletedSuccessfully,
                preloader: false,
            };

        /*
		|---------------------------------
		|        BRANCH CATEGORIES       |
		|---------------------------------
		*/

        case "FETCH_BRANCH_CATEGORIES":
            return {
                ...state,
                branchCategories: action.branchCategories,
                preloader: false,
            };
        case "FETCH_BRANCH_COMPANY_CATEGORIES":
            return {
                ...state,
                BranchCompanyCategories: action.BranchCompanyCategories,
                preloader: false,
            };

        case "REMOVE_BRANCH_CATEGORY":
            return {
                ...state,
                branchCategories: action.branchCategories,
                preloader: false,
            };

        case "UPDATE_BRANCH_CATEGORY":
            return {
                ...state,
                branchCategories: action.branchCategories,
                preloader: false,
            };

        /*
		|---------------------------------
		|        PUSH NOTIFICATIONS      |
		|---------------------------------
		*/

        case "ADD_NOTIFICATION_SIDEBAR":
            return {
                ...state,
                notifications: [action.push, ...state.notifications],
                //[action.target.storeKey]: action.target.data,
                unseenNotifications: action.unseenNotifications,
                // ...action.updates,
            };

        case "NOTIFICATION_SIDEBAR_LIST":
            return {
                ...state,
                notifications: action.notifications,
            };

        case "NOTIFICATIONS_PAGINATED_LIST":
            return {
                ...state,
                notificationsPaginated: action.notificationsPaginated,
                preloader: false,
            };
        case "REMOVE_NOTIFICATION_SIDEBAR":
            return {
                ...state,
                notifications: action.notifications,
                notificationsPaginated: action.notificationsPaginated,
                unseenNotifications: action.unseenNotifications,
                preloader: false,
            };

        case "PUSH_NOTIFICATION":
            return {
                ...state,
                notificationPushEvent: action.notificationPushEvent,
                preloader: false,
            };

        case "EMPTY_NOTIFICATION_LIST":
            return {
                ...state,
                notifications: [],
                unseenNotifications: false,
            };

        case "NOTIFICATIONS_COUNTER":
            return {
                ...state,
                notificationsCounter: action.notificationsCounter,
            };

        case "NOTIFICATIONS_UNSEEN":
            return {
                ...state,
                unseenNotifications: action.unseenNotifications,
            };

        case "NOTIFICATIONS_PAGINATION":
            return {
                ...state,
                notificationPagination: action.notificationPagination,
            };

        case "TOGGLE_TOUCHED":
            return {
                ...state,
                [action.storeKey]: action.list,
            };

        /*
		|---------------------------------
		|           UTILITIES          |
		|---------------------------------
		*/

        case "SET_USER_DEFAULT_LANGUAGE":
            return {
                ...state,
                lang_code: action.lang_code,
                json_lang: action.json_lang,
                preloader: false,
            };

        case "WAIT_FOR_RESPONSE":
            return {
                ...state,
                preloader: true,
            };

        case "SET_TABLE":
            return {
                ...state,
                table: action.table,
                preloader: false,
            };

        /* set table but using notifications */
        case "SET_TABLE_NOTIFICATION":
            return {
                ...state,
                preloader: false,
                table: action.table,
            };

        case "GEOCODER_LOADING":
            return {
                ...state,
                isLoading: action.isLoading,
                order_client_address_query: action.order_client_address_query,
            };

        case "ON_RESIZE_LISTENER":
            return {
                ...state,
                isSidebarActive:
                    action.isSidebarActive !== undefined
                        ? action.isSidebarActive
                        : state.isSidebarActive,
                isAsidemenuActive:
                    action.isAsidemenuActive !== undefined
                        ? action.isAsidemenuActive
                        : state.isAsidemenuActive,
            };

        /*
		|---------------------------------
		|            new table            |
		|---------------------------------
		*/

        case "RESET_TABLE_DATA":
            return {
                ...state,
                [action.storeAttr]: [],
                preloader: false,
            };

        /*
		|---------------------------------
		|            generator            |
		|---------------------------------
		*/
        case "INIT_PROTOYPE":
            return {
                ...state,
                infPrototype: action.infPrototype,
            };
        /*
		|---------------------------------
		|            CATEGORY            |
		|---------------------------------
		*/
        case "RESET_CATEGORY":
            return {
                ...state,
                category: action.category,
            };

        case "FETCH_CATEGORIES":
            return {
                ...state,
                categories: action.categories,
                preloader: false,
            };
        case "FETCH_CATEGORY":
            return {
                ...state,
                category: action.category,
            };
        case "CREATE_CATEGORY":
            return {
                ...state,
                [action.updateList]: state[action.updateList].concat(
                    action.category
                ),
            };
        case "UPDATE_CATEGORY":
            return {
                ...state,
                preloader: false,
                categories: [...action.categories],
                category: action.category,
            };
        case "CATEGORY_UPDATE_SUCCESS":
            return {
                ...state,
                preloader: false,
                categories: action.categories,
                category: action.category,
            };
        case "CATEGORY_DESTROY_SUCCESS":
            return {
                ...state,
                categories: action.categories,
                preloader: false,
                category: action.clear,
            };

        case "DESTROY_CATEGORY":
            return {
                ...state,
                categories: [...action.categories],
            };
        /*
		|---------------------------------
		|               APP              |
		|---------------------------------
		*/
        case "FETCH_APPS":
            return {
                ...state,
                apps: [...action.apps],
            };
        case "FETCH_APP":
            return {
                ...state,
                app: action.app,
            };

        case "FETCH_APP_PROTOTYPES":
            return {
                ...state,
                prototypes: action.prototypes,
            };

        /*
		|---------------------------------
		|             USER               |
		|---------------------------------
		*/
        case "FETCH_USERS":
            return {
                ...state,
                users: [...action.users],
            };
        case "FETCH_USER":
            return {
                ...state,
                user: action.user,
            };
        case "FETCH_USER_APPS":
            return {
                ...state,
                apps: action.apps,
            };

        /*
		|---------------------------------
		|             COMPANY            |
		|---------------------------------
		*/

        case "COMPANY_PROFILE":
            return {
                ...state,
                company: action.company,
                initCompany: action.initCompany,
                preloader: false,
            };

        case "COMPANY_SETTINGS_UPDATE":
            return {
                ...state,
                editable_company_settings: {
                    ...action.editable_company_settings,
                },
                preloader: false,
            };

        case "COMPANY_UPDATE":
            return {
                ...state,
                company: action.company,
                initCompany: action.initCompany,
                preloader: false,
            };

        case "FETCH_TOS":
            return {
                ...state,
                terms_of_service: action.terms_of_service,
                preloader: false,
            };

        case "FETCH_WORK_SCHEDULES":
            return {
                ...state,
                workSchedules: [...action.workSchedules],
                preloader: false,
            };

        case "FETCH_HOLIDAYS":
            return {
                ...state,
                companyHolidays: [...action.companyHolidays],
                preloader: false,
            };

        case "FETCH_COMPANIES":
            return {
                ...state,
                companies: action.companies,
            };

        case "REPORT_HISTORIES":
            return {
                ...state,
                reportHistories: action.reportHistories,
                preloader: false,
            }
        case "REPORT":
            return {
                ...state,
                report: action.report,
                preloader: false,
            }

        /*
		|---------------------------------
		|             ADMIN
		|---------------------------------
		*/
        case "CLEAR_ADMIN":
            return {
                ...state,
                admin: action.admin,
                dropzoneFiles: action.dropzoneFiles,
                preloader: false,
            };

        case "FETCH_ADMIN":
            return {
                ...state,
                admin: action.admin,
                preloader: false,
            };

        case "FETCH_ADMINS":
            return {
                ...state,
                admins: action.admins,
                preloader: false,
            };

        case "ADMIN_REGISTER_SUCCESS":
            return {
                ...state,
                admin: action.admin,
                admins: [...state.admins, action.admin],
                preloader: false,
            };

        case "ADMIN_UPDATE_SUCCESS":
            return {
                ...state,
                admin: action.admin,
                admins: action.admins,
                preloader: false,
            };

        case "ADMIN_UPDATE_PREFERENCES":
            return {
                ...state,
                session: {
                    ...state.session,
                    [state.session.settings.preferences]: action.preferences,
                },
                preloader: false,
            };

        case "ADMIN_RANKING":
            return {
                ...state,
                preloader: false,
            };

        case "ADMIN_DELETED":
            return {
                ...state,
                preloader: false,
                admins: action.admins,
            };

        /*
		|---------------------------------
		|             MAPS
		|---------------------------------
		*/

        case "GEOCODER_SUCCESS":
            return {
                ...state,
                autocomplete_results: action.autocomplete_results,
                isLoading: false,
            };

        case "MAP_FILTERS_VISIBILITY":
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    [action.filter]: !state.mapFilters[action.filter],
                },
            };

        case "MAP_RADIO_FILTER_VISIBILITY":
            return {
                ...state,
                mapFilters: {
                    ...state.mapFilters,
                    date: {
                        ...action.newDateFilters,
                    },
                },
            };

        case "STATIC_MAP":
            return {
                ...state,
                staticMap: action.staticMap,
            };

        /*
		|---------------------------------
		|             PROVIDER
		|---------------------------------
		*/
        case "CLEAR_PROVIDER":
            return {
                ...state,
                provider: action.provider,
                dropzoneFiles: action.dropzoneFiles,
            };

        case "CLEAR_PROVIDERS":
            return {
                ...state,
                providers: action.providers,
                preloader: false,
            };

        /* case "SET_PROVIDERS_BY_EVENT":
            return {
                ...state,
                providers: action.providers,
                preloader: false,
            }; */

        case "UPDATE_PROVIDER_GEOLOCATION":
            return {
                ...state,
                providers: action.providers,
            };

        case "FETCH_PROVIDERS":
            return {
                ...state,
                providers: action.providers,
                preloader: false,
            };

        case "FETCH_PROVIDER_SETTINGS":
            return {
                ...state,
                providerSettings: action.providerSettings,
                preloader: false,
            };

        case "FETCH_AUTOCOMPLETE_SEARCH_PROVIDERS":
            return {
                ...state,
                autocompleteProviders: action.autocompleteProviders,
                preloader: false,
            };

        case "FETCH_PROVIDER":
            return {
                ...state,
                provider: action.provider,
                preloader: false,
            };

        //!case "PROVIDER_DELETED":
        case "UPDATE_PROVIDER_SUCCESS":
            return {
                ...state,
                providers: action.providers,
                provider: action.provider,
                preloader: false,
            };

        case "REGISTER_PROVIDER_SUCCESS":
            return {
                ...state,
                provider: action.clear,
                providers: [...state.providers, action.provider],
                preloader: false,
            };

        case "AUTOCOMPLETE_PROVIDER":
            return {
                ...state,
                providers: action.providers,
            };

        case "FETCH_PROVIDER_STATISTICS":
            return {
                ...state,
                providerStatistics: action.providerStatistics,
                preloader: false,
            };

        case "FETCH_PROVIDER_ORDERS":
            return {
                ...state,
                providerOrders: action.providerOrders,
                preloader: false,
            };

        case "INVALID_ADVANCE_CONFIG":
            return {
                ...state,
                invalidConfig: action.invalidConfig,
            };

        /*
		|---------------------------------
		|             ORDERS
		|---------------------------------
		*/

        case "RESET_DATA_DETAILS_ORDER":
            return {
                ...state,
                orderDetails: action.orderDetails,
                preloader: false,
            };

        case "COMPANY_COLOR":
            return {
                ...state,
                color_accent: action.color_accent,
            };

        case "FETCH_ORDER":
            return {
                ...state,
                order: action.order,
                preloader: false,
            };
        case "FETCH_MAP_ORDERS":
            return {
                ...state,
                mapOrders: action.mapOrders || state.mapOrders,
                //!paginationOrders: state.paginationOrders,
                filteredMapOrders:
                    action.filteredMapOrders || state.filteredMapOrders,
                preloader: false,
            };

        case "CLEAR_MAP_FILTERS":
            return {
                ...state,
                filteredMapOrders: [],
            };

        case "FETCH_ORDERS":
            return {
                ...state,
                orders: action.orders,
                archived_orders: action.archived_orders,
                preloader: false,
            };

        case "SET_ORDERS_BY_EVENT":
            return {
                ...state,
                filteredMapOrders: action.orders,
                preloader: false,
            };

        case "FETCH_ARCHIVED_ORDERS":
            return {
                ...state,
                orders: action.orders,
                archived_orders: action.archived_orders,
                preloader: false,
            };

        case "FETCH_RATINGS":
            return {
                ...state,
                goodRatings: action.goodRatings,
            };

        case "FETCH_ORDER_RATINGS":
            return {
                ...state,
                orderRatings: action.orderRatings,
            };

        case "LIST_TODAY_ORDERS":
            return {
                ...state,
                todayOrders: action.todayOrders,
                ordersCounter: action.ordersCounter,
                //orders: action.orders,
            };

        case "UPDATE_TODAY_ORDERS":
            return {
                ...state,
                todayOrders: action.todayOrders,
                orders: action.orders,
                preloader: false,
            };

        case "ORDER_REGISTERED":
            return {
                ...state,
                order: action.order,
                preloader: false,
                reset_inputs: action.reset_inputs,
            };

        case "REGISTER_NEW_ORDER":
            return {
                ...state,
                cart: {
                    client_latitude_e6: 0,
                    client_longitude_e6: 0,
                    scheduled_at: "",
                    notes: "",
                    goods: [],
                    goodsQuantity: [],
                    propertiesQuantity: [],
                    delivery_method: "other", // asap or scheduled
                    isPickup: true,
                    client_address: null,
                },
                order: {
                    client_id: "",
                    client_latitude_e6: 0,
                    client_longitude_e6: 0,
                    scheduled_at: "",
                    notes: "",
                    goods: [],
                    providers_id: "",
                    propertiesGood: [],
                },
                client: {},
                autocomplete_results: [],
                properties: [],
                provider: {},
                reset_inputs: false,
                order_client_address_query: "",
                client_address: "",
            };

        case "FETCH_ORDERS_HEATMAP":
            return {
                ...state,
                ordersBranchHeatmap: action.ordersBranchHeatmap,
                preloader: false,
            };

        case "CANCEL_ORDER_ERROR":
            return{
                ...state,
                cancelOrderError: action.cancelOrderError,
                preloader: false
            };
        case "CHECKOUT_PROMO_CODE":
            return {
                ...state,
                couponCode: action.couponCode,
                preloader: false
            };
        
        case "FETCH_CLIENT_ORDERS":
            return {
                ...state,
                clientOrders: action.clientOrders,
                preloader: false,
            };

        /*
		|---------------------------------
		|             GOODS
		|---------------------------------
		*/

        case "FETCH_GOODS":
            return {
                ...state,
                goods: action.goods,
                category: action.category,
                preloader: action.preloader || false,
            };
        case "IS_UPLOADING_EXCEL":
            return {
                ...state,
                isUploadingExcel: action.isUploadingExcel,
                preloader: false,
            };
        case "FETCH_LIST_GOODS":
            return {
                ...state,
                goodsList: action.goodsList,
                goodType: action.goodType,
                category: action.category,
                preloader: action.preloader || false,
            };

        case "FETCH_LIST_GOODSBULK":
            return {
                ...state,
                goodsListBulk: action.goodsListBulk,
                preloader: action.preloader,
            };

        case "DISPLAY_LIST_GOODS":
            return {
                ...state,
                goodsList: action.goodsList,
                preloader: false,
            };

        case "REGISTER_GOOD":
            return {
                ...state,
                good: action.clear,
                goodsList: [...state.goodsList, action.good],
                preloader: false,
            };

        case "FETCH_GOOD":
            return {
                ...state,
                good: action.good,
                preloader: false,
            };

        case "GOOD_UPDATE_SUCCESS":
            return {
                ...state,
                good: action.good,
                goodsList: action.goodsList,
                preloader: false,
                dropzoneFiles: [],
            };

        case "DUPLICATE_GOOD":
            return {
                ...state,
                goods: action.goods,
                savedGood: action.savedGood,
                table: action.table,
                preloader: action.preloader || false,
            };

        case "GOOD_RESTAURED":
            break;

        case "GOOD_DELETED":
            return {
                ...state,
                goodsList: action.goodsList,
                good: action.good,
                preloader: false,
            };

        case "CLEAR_GOOD":
            return {
                ...state,
                good: action.good,
                dropzoneFiles: action.dropzoneFiles,
            };

        case "CATEGORIES_GOOD":
            return {
                ...state,
                categoriesGood: action.categoriesGood,
                allCategories: action.allCategories,
                preloader: false,
            };

        case "UPDATE_CATEGORIES_GOOD":
            return {
                ...state,
                categoriesGood: action.categoriesGood,
                allCategories: action.allCategories,
                preloader: false,
            };

        case "PROPERTIES_GOOD":
            return {
                ...state,
                propertiesGood: action.propertiesGood,
                properties: action.properties,
            };

        case "SAVE_PROPERTIES_GOOD":
            return {
                ...state,
                propertiesGood: action.propertiesGood,
                preloader: false,
            };

        case "PROPERTY_UPDATE_SUCCESS":
            return {
                ...state,
                preloader: false,
                properties: action.properties,
                property: action.property,
            };

        case "PROPERTY_DESTROY_SUCCESS":
            return {
                ...state,
                preloader: false,
                properties: action.properties,
                property: action.property,
            };

        case "ALL_PROPERTIES":
            return {
                ...state,
                properties: action.properties,
                preloader: action.preloader || false,
            };

        case "ALL_CATEGORIES":
            return {
                ...state,
                allCategories: action.allCategories,
                preloader: false,
            };
        case "CLEAR_CATEGORY":
            return {
                ...state,
                category: action.category,
                dropzoneFiles: action.dropzoneFiles,
            };

        case "GET_QUERY_IMAGES":
            return {
                ...state,
                queryImages: action.queryImages,
                preloader: false
            }

        case "GET_ORDERED_GOOD":
            return {
                ...state,
                orderedGood: action.orderedGood,
                preloader: false
            }
        
        case "ERROR_ON_ORDERED_GOOD":
            return {
                ...state,
                errorOnOrderedGood: action.errorOnOrderedGood,
                preloader: false
            }
        /*
		|---------------------------------
		|             PROPERTIES
		|---------------------------------
		*/
        case "GET_FORM":
            return {
                ...state,
                form: action.form,
            };
        case "ACTIVE_FORM":
            return {
                ...state,
                active_form: action.active_form,
                property: action.property,
            };
        case "GET_ALL_PAYMENT":
            return {
                ...state,
                allPayments: action.allPayments,
                preloader: false,
            };
        case "GET_ACEPTED_PAYMENT":
            return {
                ...state,
                aceptedpayments: action.aceptedpayments,
                preloader: false,
            };
        case "GET_ONE_PAYMENT":
            return {
                ...state,
                onePayment: action.onePayment,
                preloader: false,
            };
        case "GET_PAYMENT_FORM":
            return {
                ...state,
                payment_form: action.payment_form,
                preloader: false,
            };

        case "UPDATE_PAYMENT_FORM":
            return {
                ...state,
                payment_form: action.payment_form,
                preloader: false,
            };

        case "FORM_UPDATE_SUCCESS":
            return {
                ...state,
                table: action.table,
                preloader: false,
            };

        case "FORM_TYPE":
            return {
                ...state,
                form: action.form,
                preloader: false,
            };

        case "FETCH_PROPERTY":
            return {
                ...state,
                property: action.property,
                preloader: false,
            };

        case "FETCH_PROPERTIES":
            return {
                ...state,
                properties: action.properties,
                preloader: false,
            };

        case "CREATE_PROPERTIES":
            return {
                ...state,
                property: {},
                properties: [...state.properties, action.property],
                preloader: false,
            };

        case "FETCH_PROPERTIES_GOOD":
            return {
                ...state,
                propertiesGood: action.propertiesGood,
                properties: action.properties,
                preloader: false,
            };

        case "AUTOCOMPLETE_GOODS":
            return {
                ...state,
                goods: action.goods,
            };

        case "AUTOCOMPLETE_PROPERTIES":
            return {
                ...state,
                properties: action.properties,
            };
        /*
		|---------------------------------
		|             BRANCH PROPERTIES
		|---------------------------------
		*/

        case "ALL_BRANCH_PROPERTIES":
            return {
                ...state,
                branchProperties: action.branchProperties,
                preloader: action.preloader,
            };

        case "BRANCH_PROPERTY_UPDATE":
            return {
                ...state,
                preloader: false,
                branchProperties: action.branchProperties,
                property: action.property,
            };

        /*
		|---------------------------------
		|             ORDER
		|---------------------------------
		*/

        case "GET_CLIENT_CART":
            return {
                ...state,
                cart: action.cart,
                errorOnCart: action.errorOnCart,
                preloader: false,
            };
        case "GET_ORDER_CART":
            return {
                ...state,
                cartOrder: action.cartOrder,
                errorOnCart: false,
                preloader: false,
            };
        case "CLEAR_CART":
            return {
                ...state,
                cart: {
                    billing: {},
                    branch: {},
                    branch_id: null,
                    client_id: null,
                    created_at: null,
                    currency_iso: null,
                    delivery: {},
                    id: null,
                    items: [],
                    payment_info: {},
                    resume: {},
                    status: null,
                    updated_at: null
                },
                preloader: false,
                errorOnCart: false
            };

        case "ERROR_ON_ORDER_PAYMENT":
            return {
                ...state,
                errorOnOrderPayment: action.errorOnOrderPayment,
                preloader: false
            };

        case "ERROR_ON_RECREATE_ORDER":
            return {
                ...state,
                errorOnRecreateOrder: action.errorOnRecreateOrder,
                preloader: false
            };

        case "BUILD_ORDER":
            return {
                ...state,
                provider: action.provider,
                cart: action.cart,
            };

        case "FETCH_ORDER_DETAILS":
            return {
                ...state,
                orderDetails: action.orderDetails,
                preloader: false,
            };

        case "FETCH_ORDER_HISTORY":
            return {
                ...state,
                orderHistory: action.orderHistory,
                preloader: false,
            };

        case "ORDER_HISTORY_ERROR":
            return {
                ...state,
                orderHistoryError: action.orderHistoryError,
                preloader: false
            }

        case "FETCH_PROOF_DELIVERY":
            return {
                ...state,
                proofDelivery: action.proofDelivery,
            };

        case "ASSIGN_CLIENT_TO_ORDER":
            return {
                ...state,
                client: action.client,
            };

        case "ASSIGN_PROVIDER_TO_ORDER":
            return {
                ...state,
                provider: action.provider,
                cart: { ...state.cart, isPickup: action.isPickup },
            };

        /*
		|---------------------------------
		|             CLIENT
		|---------------------------------
		*/
        case "CLEAR_CLIENT":
            return {
                ...state,
                client: action.client,
                dropzoneFiles: action.dropzoneFiles,
            };

        case "FETCH_CLIENT":
            return {
                ...state,
                client: action.client,
                preloader: false,
            };
        case "FETCH_CLIENT_SETTINGS":
            return {
                ...state,
                clientSettings: action.clientSettings,
                preloader: false,
            };
        case "FETCH_CLIENTS":
            return {
                ...state,
                clients: action.clients,
                preloader: false,
            };
        case "FETCH_PAGINATED_CLIENTS":
            return {
                ...state,
                paginated_clients: action.paginated_clients,
                preloader: false,
            };
        case "AUTOCOMPLETE_CLIENT":
            return {
                ...state,
                clients: action.clients,
            };
        case "DESTROY_CLIENT":
            return {
                ...state,
                client: action.client,
            };

        case "UPDATE_CLIENT":
            return {
                ...state,
                paginated_clients: {
                    ...state.paginated_clients,
                    data: action.paginated_clients,
                },
                client: action.client,
                preloader: false,
            };

        case "REGISTER_CLIENT_SUCCESS":
            return {
                ...state,
                clients: [...state.clients, action.client],
                preloader: false,
            };

        case "CLIENT_DELETED":
        case "CLIENT_RESTAURED":
            return {
                ...state,
                client: action.client,
                paginated_clients: {
                    ...state.paginated_clients,
                    data: action.paginated_clients,
                },
                preloader: false,
            };

        case "ATTACHABLE_CLIENS":
            return {
                ...state,
                clientsToAsing: action.clientsToAsing,
                allClients: action.allClients,
                preloader: false,
            };

        case "ATTACHABLE_ADMINS":
            return {
                ...state,
                adminsToAsing: action.adminsToAsing,
                admins: action.admins,
                preloader: false,
            };

        /*
		|---------------------------------
		|             SECTION            |
		|---------------------------------
		*/
        case "FETCH_SECTIONS":
            return {
                ...state,
                sections: [...action.sections],
            };
        case "CREATE_SECTION":
            return {
                ...state,
                sections: state.sections.concat(action.section),
            };
        case "UPDATE_SECTION":
            return {
                ...state,
                sections: [...action.sections],
            };
        /*
		|---------------------------------
		|             TEMPLATES           |
		|---------------------------------
		*/
        case "FETCH_TEMPLATES":
            return {
                ...state,
                templates: [...action.templates],
            };
        /*
		|---------------------------------
		|             LAYOUTS            |
		|---------------------------------
		*/
        case "FETCH_LAYOUTS":
            return {
                ...state,
                layouts: [...action.layouts],
            };

        case "GET_CANCELATION_REASONS":
            return {
                ...state,
                cancelationReasons: action.cancelationReasons,
            };

        case "UPDATE_CANCELATION_REASONS":
            return {
                ...state,
                cancelationReasons: action.cancelationReasons,
                newCancelationReason: "",
                preloader: false,
            };

        case "CANCELATION_REASON":
            return {
                ...state,
                newCancelationReason: action.newCancelationReason,
            };

        case "DROPZONE":
            return {
                ...state,
                dropzoneFiles: action.dropzoneFiles,
                dropzoneActive: false,
            };
        case "CLEAR_DROPZONE":
            return {
                ...state,
                dropzoneFiles: [...action.dropzoneFiles],
                dropzoneActive: false,
            };

        case "ACTIVE_DROPZONE":
            return {
                ...state,
                dropzoneActive: true,
            };
        case "APP_MOVIL_STATUS":
            return {
                ...state,
                appMovilStatus: action.appMovilStatus,
            };

        case "UPDATE_APP_MOVIL_STATUS":
            return {
                ...state,
                appMovilStatus: action.appMovilStatus,
                preloader: false,
            };

        case "CUSTOM_EMAIL_FOOTER":
            return {
                ...state,
                customEmailFooter: action.customEmailFooter,
            };

        case "CUSTOM_CLIENT_BG":
            return {
                ...state,
                customClientBg: action.customClientBg,
            };

        case "GET_CANCELATION_REASON":
            return {
                ...state,
                cancelationReason: action.cancelationReason,
            };

        case "GET_DOLAR_TODAY":
            return {
                ...state,
                dolarToday: action.dolarToday,
            };

        case "GET_PAYMENT_METHODS":
            return {
                ...state,
                paymentMethods: action.paymentMethods,
                preloader: false,
            };

        case "GET_PAYMENT_METHODS_FORMS":
            return {
                ...state,
                paymentMethodsForms: action.paymentMethodsForms,
                preloader: false
            };

        case "GET_PENDING_ACTIONS":
            return {
                ...state,
                pendingActions: action.pendingActions,
            };

        case "GET_PAYMENT_RESPONSE":
            return {
                ...state,
                paymentResponse: action.paymentResponse,
            };

        case "GET_PAYMENT_REFERENCE":
            return {
                ...state,
                paymentReference: action.paymentReference
            };

        case "ERROR_ON_PAYMENT_REFERENCE":
            return {
                ...state,
                errorOnPaymentReference: action.errorOnPaymentReference
            };

        case "CLEAR_PAYMENT_REFERENCE":
            return {
                ...state,
                paymentReference: action.paymentReference,
                errorOnPaymentReference: action.errorOnPaymentReference
            };

        case "BUILDER_PACKAGES":
            return {
                ...state,
                builderPackages: action.builderPackages,
            };

        case "GET_BIDS":
            return {
                ...state,
                bids: action.bids,
                preloader: false,
            };

        case "UPDATE_BIDS":
            return {
                ...state,
                bids: action.bids,
                orderDetails: action.orderDetails,
                preloader: false,
            };

        case "ERROR_BIDS":
            return {
                ...state,
                errorBids: action.errorBids
            };

        case "FETCH_ALL_CLIENTS":
            return {
                ...state,
                allClients: action.allClients,
                preloader: false,
            };

        case "NEW_SERVICE_SKILL_GROUPS":
            return {
                ...state,
                new_service_skill_groups: action.new_service_skill_groups,
                preloader: false,
            };

        case "NEW_GOOD_TAG_GROUPS":
            return {
                ...state,
                new_good_tag_groups: action.new_good_tag_groups,
                preloader: false,
            };

        case "LIST_GOOD_TAG_GROUPS":
            return {
                ...state,
                good_tag_groups: action.good_tag_groups,
                new_good_tag_groups: "",
                preloader: false,
            };

        case "LIST_SERVICE_SKILL_GROUPS":
            return {
                ...state,
                service_skill_groups: action.service_skill_groups,
                new_service_skill_groups: "",
                preloader: false,
            };

        case "LIST_GOODSERVICE_SKILL_GROUPS":
            return {
                ...state,
                goodServiceSkills: action.goodServiceSkills,
                preloader: false,
            };
        case "LIST_PROPERTIES_SKILL_GROUPS":
            return {
                ...state,
                propertiesSkills: action.propertiesSkills,
                preloader: false,
            };
        case "LIST_PROVIDER_SKILLS_GROUP":
            return {
                ...state,
                providerSkillsGroups: action.providerSkillsGroups,
                preloader: false,
            };

        case "CLEAR_BIDS":
            return {
                ...state,
                bids: [],
                preloader: false,
            };
        case "FETCH_COMPANY_SECTIONS":
            return {
                ...state,
                companySections: action.companySections,
                preloader: false,
            };

        case "FETCH_COMPANY_SECTION":
            return {
                ...state,
                companySection: action.companySection,
                preloader: false,
            };

        case "ASIGNABLE_TOOGLE":
            return {
                ...state,
                productosConProveedoresAsignables:
                    action.productosConProveedoresAsignables,
                preloader: false,
            };
        case "FETCH_TIMELINEORDER":
            return {
                ...state,
                timelineOrder: action.timelineOrder,
                preloader: false,
            };

        case "FETCH_ADMINTYPE":
            return {
                ...state,
                adminType: action.adminType,
                preloader: false,
            };

        case "FETCH_BRANCH_COMPNAY_CATEGORIES":
            return {
                ...state,
                branchesCompanyCategories: action.branchesCompanyCategories,
                preloader: false,
            };

        case "FETCH_COMPANY_BRANCH_CATEGORY":
            return {
                ...state,
                companyCategory: action.companyCategory,
                preloader: false,
            };

        case "FETCH_ADMINS_ACCESS":
            return {
                ...state,
                admindAccessList: action.admindAccessList,
                preloader: false,
            };

        case "FETCH_ALLADMINTYPES":
            return {
                ...state,
                allAdminTypes: action.allAdminTypes,
                preloader: false,
            };
        case "FETCH_PROMMOTED_BANNERS":
            return {
                ...state,
                promotedBanners: action.promotedBanners,
                preloader: false,
            };

        case "FETCH_PROMMOTED_BANNER":
            return {
                ...state,
                promotedBanner: action.promotedBanner,
                preloader: false,
            };

        case "FETCH_COMPANY_BRANCH_SUBCATEGORY":
            return {
                ...state,
                companySubCategory: action.companySubCategory,
                preloader: false,
            };

        case "DATA_NOTIFICATION":
            return {
                ...state,
                sendNotification: action.sendNotification,
            };

        case "GET_BROADCASTMESSAGE":
            return {
                ...state,
                broadcastMessages: action.broadcastMessages,
                preloader: false,
            };

        case "GET_BROADCASTMESSAGE_DETAILS":
            return {
                ...state,
                broadcastMessageDetails: action.broadcastMessageDetails,
                preloader: false,
            };

        case "COMPANY_GEOFENCES":
            return {
                ...state,
                companyGeoFences: action.companyGeoFences,
                preloader: false,
            };
        case "BRANCH_GEOFENCE":
            return {
                ...state,
                branchGeoFence: action.branchGeoFence,
                preloader: false,
            };

        case "BRANCH_GEOFENCES":
            return {
                ...state,
                branchGeoFences: action.branchGeoFences,
                preloader: false,
            };

        case "BRANCH_GEOFENCE_DELIVERYFEE":
            return {
                ...state,
                branchGeoFenceDeliveryFee: action.branchGeoFenceDeliveryFee,
                preloader: false,
            };

        case "BRANCH_DELIVERY_FEEDS":
            return {
                ...state,
                branchDeliveryFees: action.branchDeliveryFees,
                preloader: false,
            };

        case "FETCH_COMPANY_DELYVERY_FEEDS":
            return {
                ...state,
                companyDeliveryFeeds: action.companyDeliveryFeeds,
                preloader: false,
            };

        case "FETCH_BALANCE_MOVEMENTS":
            return {
                ...state,
                balanceMovements: action.balanceMovements,
                preloader: false,
            };
        case "FETCH_BALANCE_MOVEMENT":
            return {
                ...state,
                balanceMovement: action.balanceMovement,
                preloader: false,
            };
        case "FETCH_BALANCE_MODIFIERS":
            return {
                ...state,
                balanceModifiers: action.balanceModifiers,
                preloader: false,
            };
        case "FETCH_BALANCE_DEBT":
            return {
                ...state,
                balanceDebt: action.balanceDebt,
                preloader: false,
            };

        case "CONFIRMATION_REAZON":
            return {
                ...state,
                confirmationOrder: action.confirmationOrder,
                preloader: false,
            };

        case "FETCH_COUPONS":
            return {
                ...state,
                coupons: action.coupons,
                preloader: false,
            };

        case "CLEAR_COUPON_DATA":
            return {
                ...state,
                coupon: {
                    name: "",
                    type: "",
                    promo_code: "",
                    human_price_prc: "",
                    human_price_e2: "",
                    applies_to: "",
                    total_count: "",
                    unlimited: false,
                    config: {
                        limit: "",
                        human_company_assumption_prc: "0",
                        only_deliveries: false,
                        only_first_purchase: false,
                        usable_in_promos: false,
                    },
                },
            };

        case "CLEAR_PROMOTION_DATA":
            return {
                ...state,
                coupon: {
                    name: "",
                    type: "",
                    promo_code: "",
                    human_price_prc: "",
                    human_price_e2: "",
                    applies_to: "",
                    total_count: "",
                    unlimited: false,
                    config: {
                        limit: "",
                    },
                },
            };

        case "FETCH_COUPON":
            return {
                ...state,
                coupon: action.coupon,
                preloader: false,
            };

        case "FETCH_VEHICLES":
            return {
                ...state,
                vehicles: action.vehicles,
                preloader: false,
            };

        case "STORE_VEHICLE":
            return {
                ...state,
                vehicle: action.vehicle,
                preloader: false,
            };
        case "FETCH_PROVIDERS_VEHICLES":
            return {
                ...state,
                providersVehicle: action.providersVehicle,
                preloader: false,
            };

        case "FETCH_BRANCH_GROUPS_VEHICLES":
            return {
                ...state,
                branchGroupsVehicle: action.branchGroupsVehicle,
                preloader: false,
            };

        case "FETCH_LOCALIZED_MESSAGES":
            return {
                ...state,
                localized_messages: action.localized_messages,
                preloader: false,
            };
        case "FETCH_APILOGS":
            return {
                ...state,
                apilogs: action.apilogs,
                preloader: false,
            };

        case "FETCH_COMPANY_CURRENCIES":
            return {
                ...state,
                companyCurrencies: action.companyCurrencies,
                currencyError: action.currencyError,
                preloader: false,
            };

        case "FETCH_COMPANY_CURRENCY":
            return {
                ...state,
                companyCurrency: action.companyCurrency,
                preloader: false,
            };

        case "FETCH_BRANCH_CURRENCIES":
            return {
                ...state,
                branchCurrencies: action.branchCurrencies,
                branchCurrencyError: action.branchCurrencyError,
                preloader: false,
            };

        case "FETCH_BRANCH_CURRENCY":
            return {
                ...state,
                branchCurrency: action.branchCurrency,
                preloader: false,
            };

        case "FETCH_BRANCH_PRICELIST":
            return {
                ...state,
                branchPriceList: action.branchPriceList,
                preloader: false,
            };

        case "FETCH_BRANCH_PRICELIST_ID":
            return {
                ...state,
                priceListId: action.priceListId,
                preloader: false,
            };

        case "STORE_NEW_BILLING":
            return {
                ...state,
                newBilling: action.newBilling,
                preloader: false,
            };

        case "LOT_BILLING_DETAILS":
            return {
                ...state,
                lotBillingsDetails: action.lotBillingsDetails,
                newBilling: action.newBilling,
                preloader: false,
            };

        case "FETCH_GENERAL_INVOICES":
            return {
                ...state,
                generalInvoices: action.generalInvoices,
                preloader: false,
            };

        case "FETCH_COMPANY_GENERAL_INVOICES":
            return {
                ...state,
                companyGeneralInvoices: action.companyGeneralInvoices,
                preloader: false,
            };
        case "FETCH_TO_PAY_COMPANY_GENERAL_INVOICES":
            return {
                ...state,
                toPayCompanyGeneralInvoices: action.toPayCompanyGeneralInvoices,
                preloader: false,
            };

        case "FETCH_INVOICE":
            return {
                ...state,
                invoice: action.invoice,
                preloader: false,
            };

        case "FETCH_GIVE_CHANGE":
            return {
                ...state,
                giveChange: action.giveChange,
                preloader: false,
            };
        case "GIVE_CHANGE_ERROR":
            return {
                ...state,
                giveChangeError: action.giveChangeError
            };
        case "FETCH_PARTIAL_GIVE_CHANGE":
            return {
                ...state,
                parcialGivechange: action.parcialGivechange,
                preloader: false,
            };
        case "FETCH_GIVE_CHANGE_HISTORY":
            return {
                ...state,
                giveChangeHistory: action.giveChangeHistory,
                preloader: false,
            };
        case "FETCH_COMPANY_COUNTRIES":
            return {
                ...state,
                companyCountriesCities: action.companyCountriesCities,
                preloader: false,
            };
        case "FETCH_COMPANY_CITIES":
            return {
                ...state,
                companyCities: action.companyCities,
                preloader: false,
            };

        case "FEATURED_GOODS":
            return {
                ...state,
                featuredGoods: action.featuredGoods,
                preloader: false,
            };

        case "FEATURED_GOOD":
            return {
                ...state,
                featuredGood: action.featuredGood,
                preloader: false,
            };
        case "FETCH_BRANCHES_LIST":
            return {
                ...state,
                branchesList: action.branchesList,
                preloader: false,
            };
        case "FETCH_BRANCHES_LIST_MAP":
            return {
                ...state,
                branchesListMap: action.branchesListMap,
                preloader: false,
            };

        case "GET_COMPANY_EARNING":
            return {
                ...state,
                companyEarning: action.companyEarning,
                preloader: false,
            };

        case "GET_SERVICE_CHARGES":
            return {
                ...state,
                serviceCharges: action.serviceCharges,
                preloader: false
            }

        case "GET_SERVICE_SUPPLIERS":
            return {
                ...state,
                serviceSuppliers: action.serviceSuppliers,
                preloader: false,
            };

        case "GET_FLEETS":
            return {
                ...state,
                fleets: action.fleets,
                preloader: false,
            };

        case "GET_ORDER_FLEETS":
            return {
                ...state,
                orderFleets: action.orderFleets,
                preloader: false
            }

        case "SET_HAS_FLEETS":
            return {
                ...state,
                hasFleets: action.hasFleets
            }

        case "GET_ONE_FLEET":
            return {
                ...state,
                fleet: action.fleet,
                preloader: false,
            };
        case "NEW_FLEET":
            return {
                ...state,
                newFleet: action.newFleet,
                preloader: false,
            };
        case "UPDATE_FLEET":
            return {
                ...state,
                updateFleet: action.updateFleet,
                preloader: false,
            };
        case "FLEET_DELETED":
            return {
                ...state,
                getFleets: action.getFleets,
                fleet: action.fleet,
                preloader: false,
            };
        case "GET_SERVICE_PROFILES":
            return {
                ...state,
                serviceProfiles: action.serviceProfiles,
                preloader: false,
            };
        case "GET_COUNTRIES":
            return {
                ...state,
                countries: action.countries,
                preloader: false,
            };
        case "GET_PAYMENT_REPORT":
            return {
                ...state,
                companyPayment: action.companyPayment,
                preloader: false,
            };

        case "NEW_FLEET_MEMBER":
            return {
                ...state,
                new_fleet_member: action.new_fleet_member,
                preloader: false,
            };

        case "GET_FLEET_MEMBERS":
            return {
                ...state,
                fleet_members: action.fleet_members,
                preloader: false,
            };

        case "GET_ASSOCIATIONS":
            return {
                ...state,
                associations: action.associations,
                preloader: false,
            };

        case "GET_FLEETS_PAYMENT_METHODS":
            return {
                ...state,
                fleetPaymentMethods: action.fleetPaymentMethods,
                preloader: false,
            };

        /*
		|---------------------------------
		|             CHATS              |
		|---------------------------------
		*/

        case "FETCH_CHAT_MEMBERS":
            return {
                ...state,
                chatMembers: action.chatMembers,
                activeInbox: action.activeInbox,
                preloader: false
            };

        case "NEW_CHAT_MEMBER":
            return {
                ...state,
                newChatMember: action.newChatMember
            };

        case "FETCH_CHATS":
            return {
                ...state,
                chats: action.chats,
                preloader: false
            };

        case "FETCH_SHOPPER_CHATS":
            return {
                ...state,
                shopperChats: action.shopperChats,
                preloader: false,
            };

        case "FETCH_PROVIDER_CHATS":
            return {
                ...state,
                providerChats: action.providerChats,
                preloader: false,
            };

        case "FETCH_CHAT_USER":
            return {
                ...state,
                chatUser: action.chatUser,
                preloader: false
            };

        case "CLEAR_CHATS":
            return {
                ...state,
                chatUser: action.chatUser,
                chats: action.chats,
                chatMembers: action.chatMembers,
                prelaoder: false
            }

        ///////////////////////////////////////////////////////

        case "TOOGLE_NOTIFICATIONS":
            return {
                ...state,
                showNotification: action.showNotification,
                preloader: false,
            };

        case "TWO_STEPS":
            return {
                ...state,
                twoSteps: action.twoSteps,
                preloader: false,
            };
            
        default:
            return state;

        /*
		|---------------------------------
		|             WEBHOOKS           |
		|---------------------------------
		*/

        case "GET_WEBHOOKS":
            return {
                ...state,
                webhooks: action.webhooks,
                preloader: false,
            };

        case "SET_WEBHOOK":
            return {
                ...state,
                webhook: action.webhook,
                preloader: false,
            };

        case "GET_WEBHOOKS_OPTIONS":
            return {
                ...state,
                webhooksOptions: action.webhooksOptions,
                preloader: false,
            };
    }
}

var store =  createStore(reducer, initialState, applyMiddleware(thunk )); //, logger));

if( !CONSOLE_LOG ){
    store =  createStore(reducer, initialState, applyMiddleware(thunk));
}
export default store;





// WEBPACK FOOTER //
// ./src/store/store.js